import React from 'react';

const ConvertIocn = (props: any) => {
  const { color, width = '18', height = '16', className = '' } = props;
  return (
    (<svg
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      className={className}
      height={height}
      viewBox="0 0 18 16"
      data-palette="ConvertIocn">
      <g fill={color}>
        <path
          stroke="var(--primaryText)"
          strokeWidth=".2"
          d="M8.762 13.977c-3.215.802-6.472-1.155-7.273-4.37-.802-3.216 1.155-6.472 4.37-7.274 3.215-.801 6.471 1.155 7.273 4.37.045.18-.064.36-.243.405-.178.044-.36-.064-.404-.243-.712-2.858-3.607-4.597-6.465-3.885-2.858.713-4.597 3.607-3.885 6.465.713 2.858 3.608 4.598 6.466 3.885.115-.029.237.006.32.092.083.086.113.209.08.323-.032.115-.124.203-.24.232z"
          transform="translate(1)"
        />
        <g>
          <path
            d="M5.676 5.275l-.496-.473c-.283.144-.606.227-.95.227-1.126 0-2.037-.87-2.037-1.943H3.21L1.853 1.79.495 3.086h1.019c0 1.43 1.215 2.59 2.716 2.59.533 0 1.027-.149 1.446-.401zM6.264 3.238H5.246l1.358 1.295 1.358-1.295H6.943c0-1.431-1.215-2.59-2.716-2.59-.533 0-1.027.149-1.446.401l.496.473c.283-.144.606-.227.95-.227 1.126 0 2.037.87 2.037 1.943z"
            transform="translate(1) rotate(-10 54.22 -38.363)"
          />
        </g>
      </g>
    </svg>)
  );
};

export default ConvertIocn;
